import TemplateCard from "./TemplateCard";

export default TemplateCard;
